import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class Arrow extends Component {
    static propTypes = {
        direction: PropTypes.oneOf(['left', 'right']).isRequired,
    };

    render() {
        const { direction } = this.props;
        return <img src={require('../../images/grid-arrow.svg')} className={['grid-arrow', direction].join(' ')} />;
    }
}



// WEBPACK FOOTER //
// ./src/components/ChannelCapabilitiesGrid/Arrow.js